import React, { memo } from 'react';
import { EdgeProps, getBezierPath, EdgeLabelRenderer } from 'reactflow';

interface WeightedEdgeData {
  weight: number;
  label?: string;
  type?: string;
}

const WeightedEdge: React.FC<EdgeProps<WeightedEdgeData>> = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style = {},
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Calculate edge thickness based on weight
  const weight = data?.weight || 1;
  const strokeWidth = Math.max(1, Math.min(8, weight * 2));
  
  // Calculate edge color based on type
  const getEdgeColor = () => {
    if (!data?.type) return '#b1b1b7';
    
    switch (data.type) {
      case 'data': return '#3b82f6'; // blue
      case 'control': return '#10b981'; // green
      case 'reference': return '#8b5cf6'; // purple
      default: return '#b1b1b7'; // gray
    }
  };

  return (
    <>
      <path
        id={id}
        style={{
          ...style,
          strokeWidth,
          stroke: getEdgeColor(),
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              background: 'white',
              padding: '2px 4px',
              borderRadius: 4,
              fontSize: 10,
              fontWeight: 500,
              pointerEvents: 'all',
              border: '1px solid #e2e8f0',
            }}
            className="nodrag nopan"
          >
            {data.label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default memo(WeightedEdge);
